import { jsx as n, jsxs as p } from "react/jsx-runtime";
import t from "../Button/index.js";
import C from "../Description/index.js";
import b from "../ListView/index.js";
import g from "../Modal/index.js";
import h from "../../hooks/useTranslation.js";
const k = "common", M = { confirmation: "Confirmation", confirmMessage: "Are you sure you want to continue?", buttonCancel: "Cancel", buttonOk: "Ok" }, O = {
  namespace: k,
  strings: M
};
function V(r) {
  const o = h(O), {
    heading: s = o.confirmation,
    message: a = o.confirmMessage,
    cancelLabel: c = o.buttonCancel,
    confirmLabel: m = o.buttonOk,
    disabled: i,
    name: l,
    onCancel: e,
    onClose: f = e,
    onConfirm: d,
    ...u
  } = r;
  return /* @__PURE__ */ n(
    g,
    {
      closeOnEscape: !1,
      size: "sm",
      ...u,
      heading: s,
      onClose: f,
      footerActions: /* @__PURE__ */ p(b, { spacing: "sm", children: [
        /* @__PURE__ */ n(
          t,
          {
            name: void 0,
            onClick: e,
            disabled: i,
            children: c
          }
        ),
        /* @__PURE__ */ n(
          t,
          {
            name: l,
            styleVariant: "filled",
            onClick: d,
            disabled: i,
            children: m
          }
        )
      ] }),
      children: /* @__PURE__ */ n(C, { children: a })
    }
  );
}
export {
  V as default
};
